import { IBusiness } from 'core/model/interfaces/business.interface';

export const formatCkeckBoxAddressLabel = (addressItem: Partial<IBusiness>) =>
  `${addressItem.address} - ${addressItem.district} - ${addressItem.province} - ${addressItem.department}`;
